<template>
  <div class="px-6 py-10 text-center sm:px-12 sm:py-12">
    <h1 class="px-6 font-serif text-3xl leading-tight text-charcoal-700 sm:text-4xl">
      Connect with {{user.name}}
    </h1>

    <div class="my-6 text-lg leading-relaxed text-charcoal-500">
      <p>
        Connect to see shared content and follow this profile.
      </p>
    </div>

    <div class="flex flex-col items-center gap-3">
      <u-button
        size="xl"
        :icon="COMMON_ICONS.add"
        label="Add Connection"
        :loading="isSaving"
        class="w-64 justify-center font-semibold"
        @click="addConnection"
      />
      <u-button
        size="xl"
        color="charcoal"
        variant="soft"
        label="Not now"
        :disabled="isSaving"
        class="w-64 justify-center font-semibold"
        @click="modal.close()"
      />
    </div>

    <p class="mt-6 text-sm text-charcoal-400">
      You can continue browsing the public profile without connecting.
    </p>
  </div>
</template>

<script setup>
  const props = defineProps({
    modal: Object,
    user: {
      type: Object,
      required: true
    }
  });

  const isSaving = ref(false);

  async function addConnection() {
    try {
      isSaving.value = true;
      await useUsersStore().addConnection({user: props.user});
      await props.modal.close();
    } catch (e) {
      useErrorToast().add();
    } finally {
      isSaving.value = false;
    }
  }
</script>
